import { createSlice } from '@reduxjs/toolkit';

const emptyList = { rows: [], total: 0, page: 1, pageSize: 20 };

const slice = createSlice({
  name: 'affiliate',
  initialState: {
    dashboard: null,
    referrals: emptyList,
    commissions: emptyList,
    withdrawals: null
  },
  reducers: {
    getDashboard: () => { },
    getDashboardSuccess: (state, action) => { state.dashboard = action.payload; },
    getReferrals: () => { },
    getReferralsSuccess: (state, action) => { state.referrals = action.payload; },
    getCommissions: () => { },
    getCommissionsSuccess: (state, action) => { state.commissions = action.payload; },
    getWithdrawals: () => { },
    getWithdrawalsSuccess: (state, action) => { state.withdrawals = action.payload; },
    requestWithdraw: () => { },
    sendInvite: () => { },
    reset: () => ({ dashboard: null, referrals: emptyList, commissions: emptyList, withdrawals: null })
  }
});

export const {
  getDashboard, getDashboardSuccess, getReferrals, getReferralsSuccess, getCommissions, getCommissionsSuccess,
  getWithdrawals, getWithdrawalsSuccess, requestWithdraw, sendInvite, reset
} = slice.actions;
export default slice.reducer;
